import { Box, Stack, Text, Image } from "grommet";
import React, { useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { AliasTile } from "../../aliases/AliasTile";
import { useQueryNumber, useQuerySwitch } from "../../general/Helpers";
import LiveHub from "../../general/LiveHub";
import { AliasMatchParticipantViewModel } from "../../matches/MatchesStore";
import { getTournament } from "../TournamentsStore";
import { getNextMatch } from "../LiveStreamComponents";

import { TeamViewModel } from "../../teams/TeamsStore";
import { ConstellationCanvas, StarrySkyCanvas } from "../../components/themes/galaxy/GalaxyComponents";

export const TournamentTeamPlayerGalaxyWrapper = () => {
    const [ts, setTs] = React.useState(+Date.now());

    let { id, participant, player } = useParams<{ id: string; participant: string; player: string }>();
    const [participantAlias, setParticipantAlias] = React.useState({} as AliasMatchParticipantViewModel);
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        resolve();
    }, []);

    const matchNumber = useQueryNumber("matchNumber", 0);

    const resolve = () => {
        getTournament(id).then((tournament) => {
            let match = getNextMatch(tournament, matchNumber);
            if (match && participant && player) {
                try {
                    setTeam(match.participants[+participant]?.team);

                    if (match.tournamentID) {
                        let teamParticipants = (tournament.participants?.find((tournamentParticipant) => tournamentParticipant.teamID == team.id)?.aliases || []).map(
                            (tournamentAliasParticipant) =>
                                ({
                                    alias: tournamentAliasParticipant.alias,
                                    team: team,
                                    aliasID: tournamentAliasParticipant.aliasID,
                                    id: tournamentAliasParticipant.id,
                                    teamID: team.id,
                                    teamName: team.name,
                                    participantID: tournamentAliasParticipant.id,
                                    stats: [],
                                } as AliasMatchParticipantViewModel)
                        );
                        setParticipantAlias(teamParticipants[+player] || {});
                    } else {
                        setParticipantAlias(match.participants[+participant]?.aliases[+player] || {});
                    }

                    setParticipantAlias(match.participants[+participant]?.aliases[+player] || {});
                } catch (e) {
                    setParticipantAlias({} as AliasMatchParticipantViewModel);
                }
            } else {
                setParticipantAlias({} as AliasMatchParticipantViewModel);
            }
            console.log("interactive");
        });
    };

    const useTeamColor = useQuerySwitch("useTeamColor");

    return (
        <LiveHub entities={[id]} handleUpdate={resolve}>
            <Box justify="evenly" direction="row">
                <Stack fill anchor="left" guidingChild={1}>
                    <StarrySkyCanvas color={useTeamColor ? team?.color : "white"}></StarrySkyCanvas>
                    {participantAlias.aliasID && (
                        <Box fill justify="center" align="center" style={{ minHeight: "100vh" }} background={{ image: `url(${team.logoUri})`, opacity: 0.05 }}>
                            {/* <AliasTile alias={participantAlias.alias} profileOnly size="large" imageSizeOverride="800px" hideName></AliasTile> */}
                            <Box align="center" justify="center" style={{ maxHeight: "80vh", overflow: "hidden" }}>
                                {participantAlias.alias.profileUri && <Image src={participantAlias.alias.profileUri + "?ts=" + ts} width={"800px"}></Image>}
                                {!participantAlias.alias.profileUri && <Image src={"/images/faces/blank.png"} width={"800px"}></Image>}
                            </Box>
                            <Text size="48px" style={{ fontFamily: "Calamity" }}>
                                {participantAlias.alias.name.toUpperCase()}
                            </Text>
                        </Box>
                    )}
                    <ConstellationCanvas camera={{ position: [0, 0, 25], fov: 50 }} color={useTeamColor ? team?.color : "white"} style={{ height: "100vh", width: "60vw" }}></ConstellationCanvas>
                </Stack>
            </Box>
        </LiveHub>
    );
};
